import { createGlobalStyle} from "styled-components";

export const GlobalStyles = createGlobalStyle`
  :root{
    --primary-color: ${({ theme }) => theme.colors.text};
    --secondary-color:${({theme})=> theme.colors.secondaryText};
    --background-color:${({theme})=> theme.colors.backgroundColor};
    --button-color:${({theme})=> theme.colors.button.text}
  }
  body {
    background: ${({ theme }) => theme.colors.body};
    color: var(--primary-color);
    font-family: ${({ theme }) => theme.font};
    
  }

  a {
    color: ${({ theme }) => theme.colors.link.text};
    cursor: pointer;
    text-decoration:none;
  }

  button {
    border: 0;
    display: inline-block;
    padding: 12px 24px;
    font-size: 14px;
    border-radius: 4px;
    margin-top: 5px;
    cursor: pointer;
    background-color: ${({theme})=>theme.colors.button.background};
    color: ${({theme})=>theme.colors.button.text};
    font-family: ${({ theme }) => theme.font};
  }

  a.btn {
    background-color: ${({ theme }) => theme.colors.button.background};
    color: ${({ theme }) => theme.colors.button.text};
  }
  h2{
    color:${({ theme })=>theme.colors.heading.h2Color};
  }
  h1{
    color:${({ theme })=>theme.colors.heading.h1Color};
  }
`;